<template>
  <div>
    <div class = "upperLine">{{field1}}</div>
    <div class = "lowerLine">{{field2}}</div> 
  </div>
</template>

<style>
  .upperLine {
    margin: 0;
    /* text-align: left; */
  }

  .lowerLine {
    margin : 0;
     padding:0; 
     margin-bottom: 10px;
     line-height : 1px;
  }
</style>

<script>

  export default {
    props: {
      field1: String,
      field2: String,
    },
    computed: {
      
    },
    methods: {
      
    },

  }

</script>
